import React from 'react';
import {Checkbox} from 'semantic-ui-react';

import AutoSaveField from './abstract/AutoSaveField.jsx';

class AutoSaveCheckbox extends React.Component {
    constructor(props) {
        super(props);
    }

    getValue(event, data) {
        return data.checked;
    }

    render() {
        return (
            <AutoSaveField control={Checkbox}
                           fieldLabel={this.props.fieldLabel}
                           getValueFromOnChange={(event, data) => this.getValue(event, data)}
                           defaultChecked={this.props.defaultValue === true}
                           name={this.props.field.name}
                           {...this.props} />
        )
    }
}

export default AutoSaveCheckbox;


// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveCheckbox.jsx